'use client';

import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { SkipToolBtn } from '@prismo-io/feature-tsid';
import { Application, useRouter } from '@prismo-io/router';
import type { LanguageCodeT } from '@prismo-io/schemas';
import {
  type ComponentProps,
  type FC,
  useCallback,
  useTransition,
} from 'react';

type Props = {
  tool: ComponentProps<typeof SkipToolBtn>['tool'];
  stepIdx: number;
};

export const SkipTsidToolBtn: FC<Props> = (props) => {
  const { tool, stepIdx } = props;

  const [isTransiting, startTransition] = useTransition();

  const isSubmitting = false;

  const router = useRouter();

  const { i18n } = useLingui();

  const onSkip = useCallback(() => {
    startTransition(() => {
      router.push({
        app: Application.ONBOARDING,
        path: '/parcours/etapes/:step',
        params: {
          step: stepIdx + 1,
        },
        locale: i18n.locale as LanguageCodeT,
      });
    });
  }, [startTransition, router, stepIdx, i18n.locale]);

  return (
    <SkipToolBtn
      tool={tool}
      variant="text"
      color="gray"
      onClick={onSkip}
      disabled={isTransiting || isSubmitting}
    >
      <Trans>Passer</Trans>
    </SkipToolBtn>
  );
};
